// A 403 the server sends on purpose, with a message for the user (the shared enquiry permissions answer
// {"error": "...", "refusal": true}), as opposed to the 401/403 of a missing or expired token. A refusal must
// reach the screen that made the call: it is not retried after a token refresh and does not log the user out.
export function isRefusal(response) {
  return !!(response && response.status === 403 && response.data && response.data.refusal === true)
}

// The server's message for a save it refused for the user to fix: a 409 (a job field changed on one customer's
// enquiry of a shared job; the same customer + product type twice on a job, guard "database") or a refusal 403.
// null for any other failure, which keeps its generic message.
export function refusalMessage(e) {
  const r = e && e.response
  if (!r || !(r.status === 409 || isRefusal(r))) return null
  const d = r.data
  if (d && typeof d.error === 'string' && d.error) return d.error
  if (typeof d === 'string' && d) return d
  return null
}
